import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import FormFields from '../commons/FormFields';
import SetDeliveryModeContext from '../commons/SetDeliveryModeContext';

class EditNewDeliveryModeContext extends React.Component {

  render () {
    const { data, onChange } = this.props;
    return (
      <FormFields>
        <SetDeliveryModeContext
          data={data}
          onChange={(data) => onChange(data)}
        />
      </FormFields>
    );
  }
}

const styles = theme => ({});

EditNewDeliveryModeContext.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  data: PropTypes.object,
};

EditNewDeliveryModeContext.defaultProps = {
  data: {}
};

export default withStyles(styles, { withTheme: true })(EditNewDeliveryModeContext);
